module.exports = __webpack_public_path__ + "assets/img/aboutUS-module1-5.a3ded775.jpg";